import SchoolLinksManagerOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined';
import StudentObserverOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import { useTranslation } from 'react-i18next';

import { SidebarTypes } from 'layout/MainLayout/components/Sidebar/types';
import { RoutePath } from 'shared/constants/router';
import { useIsAdminView, useUserRole } from 'shared/hooks/user';
import { UserRole } from 'shared/types';

import { useAdminSchoolLinksNavigationItems } from './hooks';

import type { NavigationItem } from 'layout/MainLayout/components/Sidebar/types';

export const useAdminNavigationItems = (): NavigationItem[] => {
  const { t } = useTranslation();
  const isAdminView = useIsAdminView();
  const role = useUserRole();
  const adminSchoolLinksNavigationItems = useAdminSchoolLinksNavigationItems();

  return !isAdminView && (role === UserRole.Staff || role === UserRole.Admin)
    ? [
        {
          label: t('sidebar.studentObserver'),
          icon: <StudentObserverOutlinedIcon />,
          to: RoutePath.StudentObserver,
          sidebarType: SidebarTypes.ADMIN,
        },
        ...adminSchoolLinksNavigationItems,
        {
          label: t('sidebar.schoolLinksManager'),
          icon: <SchoolLinksManagerOutlinedIcon />,
          to: RoutePath.SchoolLinksManager,
          sidebarType: SidebarTypes.ADMIN,
        },
      ]
    : [];
};
